import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const DestinationService = {
  getList: async () => {
    const response = await apiService.get("/destinationcountries");
    console.log(response);
    return response.data;
  },

  createDestination: async (payload) => {
    const response = await apiService.post("/destinationcountries", payload);
    return response.data;
  },
  createDestinationIntell: async (id, payload) => {
    const response = await apiService.post(
      `/countrywiseintellsection/${id}`,
      payload,
    );
    return response.data;
  },
  // Fetch single destination detail
  getDetail: async (id) => {
    const response = await apiService.get(`/destinationcountries/${id}`);
    return response.data;
  },
  getBySlug: async (id) => {
    const response = await apiService.get(
      `/destinationcountries/slug?slug=${id}`,
    );
    return response.data;
  },
  updateDestination: async (id, payload) => {
    const response = await apiService.put(
      `/destinationcountries/${id}`,
      payload,
    );
    return response.data;
  },
  updateDestinationIntell: async (id, payload) => {
    const response = await apiService.put(
      `/countrywiseintellsection/${id}`,
      payload,
    );
    return response.data;
  },
  deleteDestination: async (id, payload) => {
    const response = await apiService.delete(
      `/destinationcountries/${id}`,
      payload,
    );
    return response.data;
  },
  deleteDestinationIntell: async (id, payload) => {
    const response = await apiService.delete(
      `/countrywiseintellsection/${id}`,
      payload,
    );
    return response.data;
  },

  getDetailIntell: async (id) => {
    const response = await apiService.get(
      `/countrywiseintellsection/by-country/${id}`,
    );
    return response.data;
  },

   getInitialField: async (id) => {
    const response = await apiService.get(
      `/countrywiseintellsection/${id}`,
    );
    return response.data;
  },
};
export default DestinationService;
